export default __webpack_public_path__ + "static/bg-6-416beaa534ed5eb1fac24daf29f9fa08.jpg";